import React from 'react';

export default function CropPlate() {
    return (
        <svg width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="currentColor"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                d="M5 2.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM16.5 18a.5.5 0 1 1 0 1h-9A2.5 2.5 0 0 1 5 16.5v-9a.5.5 0 0 1 1 0v9A1.5 1.5 0 0 0 7.5 18zm4 1a.5.5 0 1 1 0-1h1a.5.5 0 1 1 0 1zM2.5 6a.5.5 0 0 1 0-1h14A2.5 2.5 0 0 1 19 7.5v14a.5.5 0 1 1-1 0v-14A1.5 1.5 0 0 0 16.5 6z"
            />
        </svg>
    );
}
